module.exports = __webpack_public_path__ + "static/media/mobile_home_colored_icon.709ae825.svg";